import { i18n } from "../translate/i18n";

const { t } = i18n;

export const COLUMNS_IDENTIFIERS = Object.freeze({
  AVERAGE_SALES: 'averageSales',

  CREATED_AT: 'createdAt',

  DEPARTMENT: 'department',

  EFFECTIVE_PURCHASE: 'effectivePurchase',
  EMAIL: 'email',
  
  LEAD_TIME: 'leadTime',  

  MIN_STOCK: 'minStock',

  ORDER_DATE: 'orderDate',
  ORDER_ID: 'orderId',
  ORDER_STATUS: 'orderStatus',  

  PACK_TO_UNIT_RATIO: 'packToUnitRatio',
  PHYSICAL_STOCK: 'physicalStock',
  PREFIX_NAME: 'prefixName',
  PREFIX_DESCRIPTION: 'prefixDescription',
  PRODUCT_SUBGROUP_NAME: 'productSubgroupName',
  PRODUCT_NAME: 'productName',
  PURCHASE_REC_7: 'purchaseRec7',
  PURCHASE_REC_14: 'purchaseRec14',
  PURCHASE_REC_21: 'purchaseRec21',
  PURCHASE_RECOMMENDATION: 'initialPurchaseRecommendation',

  SUPPLIERS: 'suppliers',
  SUPPLIER_NAME: 'supplierName',  
  STORES: 'stores',

  UI_PURCHASE_DATE: 'uiPurchaseDate',
  USERNAME: 'username',
});

export const COLUMNS_LABELS = Object.freeze({
  CODE: t("code"),
  DEPARTMENT: t("level"),
  DESCRIPTION: t("description"),
  DETAILS: t("details"),
  EFFECTIVE_PURCHASE: t("effectivePurchase"),
  EMAIL: t("email"),
  LEAD_TIME: t("leadTime"),
  MODIFY: t("actions"),
  ORDER_DATE: t("orderDateSent"),
  ORDER_ID: "Nº do Pedido",
  ORDER_STATUS: 'Status',
  PACK_TO_UNIT_RATIO: t("conversionFactor"),
  PHYSICAL_STOCK: t("supply"),
  PRODUCT: t("product"),
  PROJECTED_SALES: t("purchaseSuggestion"),
  REGISTERED_ON: t("registeredOn"),
  STORES: t("stores"),
  SUBGROUP: t("subgroup"),
  SUPPLIER: t("supplier"),
  SUPPLIERS: t("suppliers"),
  UNIT_OF_MEASURE: t("acronym"),
  USERNAME: t("buyer"),
  USERNAME_MANAGEMENT: t("user"),
});

export const COLUMNS_DESCRIPTIONS = Object.freeze({
  SUPPLIERS: t("vendorList"),
  SUBGROUP: t("productSubgroups"),
  PRODUCT: t("storeProducts"),
  PHYSICAL_STOCK: t("stockUnits"),
  AVERAGE_SALES: t("productSalesAverage"),
  PROJECTED_SALES: t("purchaseSuggestion"),
  PACK_TO_UNIT_RATIO: ("conversionFactorDescription")
})

export const HIDEABLE_COLUMNS = Object.freeze([
  { id: COLUMNS_IDENTIFIERS.SUPPLIERS, label: t("suppliers") },
  { id: COLUMNS_IDENTIFIERS.PRODUCT_SUBGROUP_NAME, label: t("subgroup") },
  { id: COLUMNS_IDENTIFIERS.PRODUCT_NAME, label: t("product") },
  { id: COLUMNS_IDENTIFIERS.PHYSICAL_STOCK, label: t("supply") },
  { id: COLUMNS_IDENTIFIERS.AVERAGE_SALES, label: t("averageSales") },
  { id: COLUMNS_IDENTIFIERS.PURCHASE_REC_7, label: t("purchaseSuggestion7") },
  { id: COLUMNS_IDENTIFIERS.PURCHASE_REC_14, label: t("purchaseSuggestion14") },
  { id: COLUMNS_IDENTIFIERS.PURCHASE_REC_21, label: t("purchaseSuggestion21") },
  { id: COLUMNS_IDENTIFIERS.PURCHASE_RECOMMENDATION, label: t("recommendedPurchase") },
  { id: COLUMNS_IDENTIFIERS.EFFECTIVE_PURCHASE, label: t("actualPurchase") },
  { id: COLUMNS_IDENTIFIERS.PREFIX_NAME, label: t("acronym") },
  { id: COLUMNS_IDENTIFIERS.PACK_TO_UNIT_RATIO, label: t("conversionFactor"), },
  { id: COLUMNS_IDENTIFIERS.MIN_STOCK, label: t("minimumInventory") },
  { id: COLUMNS_IDENTIFIERS.LEAD_TIME, label: t("leadTime") }
]);

export const COLORS = Object.freeze({
  GREEN_ARROW: '#5CB85C',
  GREEN_CURRENT_TABLE_VALUE: '#36A70D',
  CELL_VALUE_COLOR: '#626772',
  GRAY_VALUE: '#dee2e6',
})

export const ALLOWED_PURCHASE_STATUS = Object.freeze({
  SUGGESTED: 'SUGGESTED',
  EDITED: 'EDITED',
  FINALIZED: 'FINALIZED',
  CANCELED: 'CANCELED',
  FINALIZED_EDITED: 'FINALIZED_EDITED'
});

export const ORDER_STATUS = Object.freeze({
  REALIZED: 'REALIZED',
  CANCELED: 'CANCELED',
  CONCLUDED: 'CONCLUDED'
});

export const ORDER_ITEM_STATUS = Object.freeze({
  EDITED_FINALIZED: 'revisado',
  ACTIVE: 'ACTIVE',
  CONCLUDED: 'CONCLUDED',
  INACTIVE: 'INACTIVE',
  CANCELED: 'CANCELED'
});

export const USER_ROLES = Object.freeze({
  ADMIN: 'ADMIN',
  FASHION_DESIGNER: 'ESTILISTA',
  INDUSTRY_DIRECTOR: 'DIRETOR',
  REGIONAL_GAS_STATION: 'REGIONAL',  
  SHOPKEEPER: 'LOJISTA',
  TENANT_ADMIN: 'TENANT_ADMIN',
});

export const OPPORTUNITY_STATUS = Object.freeze({
  ACTIVE: "active",
  CHECKOUT: "checkout",
  FINISHED: 'finished',
  REMOVED: "removed"
});

export const ORDERING_MODES = Object.freeze({
  ASCENDING: "ascending",
  DESCENDING: "descending"
});

export const TENANT_CATEGORY = Object.freeze({
  RETAIL: 'retail',
  GAS_STATION: 'gas station'
});

export const GROUP_BY = Object.freeze({
  HORIZON: 'horizon',
  QUARTER: 'quarter'
});

export const MEDIAN_MODE = Object.freeze({
  FIXED: 'fixed',
  ALL: 'all'
});

export const COMPANY_STORE_ID = Object.freeze({
  STORE_ID: 9999
});

export const SEASONS_NAMES_DEFAULT = Object.freeze({
  ALL_SEASONS: 'Todas as coleções'
});

export const TABLE_TYPE = Object.freeze({
  ACCURACY: 'accuracy'
});

export const DEFAULT_VALUES = Object.freeze({
  NOT_APPLY: "N/A"
});

export const ELIGIBLE_ORDERS_STRATEGY_VALUES = Object.freeze({
  WITH_USER_INPUTS: 'with_inputs',
  API_DATA: 'data_from_api',
  ELIGIBLE_ORDERS: 'eligible_orders'
});

export const ASSORTMENT_INDUSTRY_TABS = Object.freeze({
  PRODUCT_PERFORMANCE: 'product_performance',
  PERFORMANCE_PREDICTION: 'estimates',
  HISTORICAL_FINANCE: 'financial',
  HISTORICAL_MATRIX: 'historical',
  MIX_QUALIFICATION: 'mix_qualification'
});

export const RETAIL_INVENTORY_QUALITY_TABS = Object.freeze({
  AVOID_LOSS: 'evitar_perda',
  LOSS_BY_STORE: 'perda_por_loja',
  ANALYZE_SIZE_CURVE: 'analisar_grade'
});

export const OTB_VIEWS = Object.freeze({
  OPEN_TO_BUY: "abertura de compra",
  DETAILED_OTB: "otb detalhado",
  SALES_PLAN: "plano de compra",
  OTB_PERFORMANCE: {
    LABEL: "Performance",
    VALUE: "performance do otb",
  },
  OTB_CONFIGURATION: {
    LABEL: "Setup",
    VALUE: "parâmetros de configuração do otb"
  }
});

export const PREDICTON_COLORS = [
  "#f58b4d",
  "#BFBFBF",
  "#9544d2", //roxo
  "#12a9b3", //azul claro
  "#aeaa10", //amarelo escuro
  "#e52590", //rosa
  "#178751", //verde escuro
  "#eb3c3c", //vermelho
  "#5d62f6", //azul escuro
  "#b2f65d", //verde limão
  "#f8fa4f", //amarelo claro  
]

export const LOCATION_VALUES_FOR_PREDICTION_CHART = {
  OPPORTUNITY_ACCORDION: "opportunity_accordion",
  OPPORTUNITY_ACCORDION_ADVANCED_OPP_BTN: "button_from_opportunity_accordion"
}

export const OTB_EDITABLE_FIELDS = Object.freeze({
  FATURAMENTO: 'grossRevenue',
  PRECO_MEDIO: 'originalPrice',
  PECAS_VENDIDAS: 'unitsSold'
})